/* eslint-disable react-hooks/exhaustive-deps */
import { stopPropagation } from '../../../../../../utils';
import { Modal, Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

export const DeactivateExternalLinked = (props) => {
  const { t } = useTranslation();
  const {
    confirmDeactivateModel: modal,
    toggleConfirmDeactivateModel: toggle,
    setConfirmedDeactivation: deactivate,
  } = props;

  const confirmDeactivate = () => {
    deactivate(true);
    toggle();
  };

  return (
    <Modal
      open={modal}
      onOpen={() => toggle()}
      onClick={(e) => stopPropagation(e)}
      onFocus={(e) => stopPropagation(e)}
      closeIcon={
        <div className="new-activity-modal-close-icon" onClick={() => toggle()}>
          &times;
        </div>
      }
      size="tiny"
    >
      <Modal.Header>
        <div className="small-modal-header">
          {t(
            'activity.activity_plan.linked_activity.deactivate_external_linked_activity'
          )}
        </div>
      </Modal.Header>
      <Modal.Content className="deactivation-modal-content">
        <div className="no-feature-warning-box w-100">
          <div className="padding-issue">
            {t(
              'activity.activity_plan.linked_activity.deactivate_external_linked_activity_confirmation'
            )}
          </div>
        </div>
        <p>
          {t(
            'activity.activity_plan.linked_activity.proceed_with_deactivation'
          )}
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={() => toggle()}
          className="activity-activation-cancel-btn"
        >
          {t('actions.no')}
        </Button>
        <Button
          onClick={() => confirmDeactivate()}
          className="new-collective-save-btn"
          content={t('actions.yes')}
        />
      </Modal.Actions>
    </Modal>
  );
};
